import {Outlet, useRoutes} from "react-router-dom";
import {LoadComponent} from "@loadComponent";
import {lazy} from "react";

const List = lazy(() => import('./List'));
const Room = lazy(() => import('./Room'));
const CourtHearingsCalendar = lazy(() => import('./pages/CourtHearingsCalendar'));

const Hearing = () => {

    return useRoutes([
        {
            path: '',
            element: <LoadComponent component={List}/>,
            children: [
                {
                    path: '',
                    element: <LoadComponent component={CourtHearingsCalendar}/>
                },
                {
                    path: 'court/:courtId',
                    element: <Outlet/>,
                    children: [
                        {
                            path: 'edit',
                            element: <LoadComponent component={CourtHearingsCalendar}/>
                        },
                        {
                            path: 'event/:eventId/view',
                            element: <LoadComponent component={CourtHearingsCalendar}/>
                        },
                    ]
                },
            ],
        },
        {
            path: ':eventId/room',
            element: <LoadComponent component={Room}/>
        },
        {
            path: ':id/view',
            element: <LoadComponent component={List}/>
        }
    ]);
};

export default Hearing;
